import styled from '@emotion/styled'
export const StyleWrapper = styled.div`
  position: relative;
`
export const StyleSearchWrapper = styled.div`
  border: 1px solid ${(props: any) => props.theme.colors.inputBorder};
  border-radius: 8px;
  padding: 0px 10px;
  padding-bottom: 10px;
  position: absolute;
  width: 100%;
  top: 50px;
  z-index: 111;
  background: white;
  max-height: 250px;
  background: white;
  overflow-y: auto;
`

export const StyleSearchItem = styled.div`
  border-bottom: 1px solid ${(props: any) => props.theme.colors.inputBorder};
  padding: 15px 10px;
  display: flex;
  align-items: center;
  column-gap: 10px;
`
